export default __webpack_public_path__ + "static/media/droit.8639e511.svg";